import React from 'react'
import { Annoucement, Disclaimer, Home, Payment, Service, User, Star, PrivacyIcon, TermsIcon, AboutUsIcon, Intention, Prompt, Reflection, Build, SendNotification } from './Icons'
import { NavLink } from 'react-router-dom';

export default function Sidebar() {

    return (
        <>
            <aside id='sidebar' className='sidebar'>
                <ul className='sidenav' id='sidenav'>

                    {/* Dashboard */}
                    <div className="menu_title">Dashboard</div>
                    <li className="nav-item">
                        <NavLink exact activeClassName="active" to="/" className="nav-link">
                            <span><Home /></span>
                            <span>Dashboard</span>
                        </NavLink>
                    </li>

                    <div className="menu_title">Management</div>

                    <li className="nav-item">
                        <NavLink exact activeClassName="active" to="/user-management" className="nav-link">
                            <span><User /></span>
                            <span>Users</span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink exact activeClassName="active" to="/prompt-management" className="nav-link">
                            <span><Prompt /></span>
                            <span>Propmts</span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink exact activeClassName="active" to="/question-prompt-management" className="nav-link">
                            <span><Annoucement /></span>
                            <span>Question Propmts</span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink exact activeClassName="active" to="/passion-ideas" className="nav-link">
                            <span><Annoucement /></span>
                            <span>Passion Ideas</span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink exact activeClassName="active" to="/qoutes-management" className="nav-link">
                            <span><Service /></span>
                            <span>Quotes</span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink exact activeClassName="active" to="/intentions-management" className="nav-link">
                            <span><Intention /></span>
                            <span>Intentions</span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink exact activeClassName="active" to="/reflections-management" className="nav-link">
                            <span><Reflection /></span>
                            <span>Reflections</span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink exact activeClassName="active" to="/send-notification" className="nav-link">
                            <span><SendNotification /></span>
                            <span>Send Notification</span>
                        </NavLink>
                    </li>
                    {/* <li className="nav-item">
                        <NavLink exact activeClassName="active" to="/build" className="nav-link">
                            <span><Build /></span>
                            <span>Build Version</span>
                        </NavLink>
                    </li> */}

                    <div className="menu_title">Content Management</div>

                    <li className="nav-item">
                        <NavLink exact activeClassName="active" to="/privacy-policy" className="nav-link">
                            <span><PrivacyIcon /></span>
                            <span>Privacy Policy</span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink exact activeClassName="active" to="/terms-and-condition" className="nav-link">
                            <span><TermsIcon /></span>
                            <span>Terms & conditions</span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink exact activeClassName="active" to="/about-us" className="nav-link">
                            <span><AboutUsIcon /></span>
                            <span>About Us</span>
                        </NavLink>
                    </li>
                </ul>
            </aside>
        </>
    )
}


